import type { FC } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import styles from "./WalletColumnTitle.module.css";

import { AppStrings } from "../../../utils/constants/AppStrings";

const WalletColumnTitle: FC = () => (
  <span className={styles.title}>
    <span>{AppStrings.WALLET}</span>
    <Tooltip title={AppStrings.WALLET_7D_CHANGE_TOOLTIP}>
      <InfoCircleOutlined
        className={styles.infoIcon}
        aria-label={AppStrings.WALLET_7D_CHANGE_TOOLTIP}
      />
    </Tooltip>
  </span>
);

export default WalletColumnTitle;
